import * as styles from './StarWincon.module.css'

import React from 'react'

export const StarWincon: React.FC = () => {
  return (
    <div className={styles.container}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
        <circle className={styles.cls9} cx="100" cy="28" r="10" />
        <circle className={styles.cls7} cx="31.52" cy="77.75" r="10" />
        <circle className={styles.cls7} cx="57.68" cy="158.25" r="10" />
        <circle className={styles.cls9} cx="142.32" cy="158.25" r="10" />
        <circle className={styles.cls6} cx="168.48" cy="77.75" r="10" />
        <circle className={styles.cls1} cx="100" cy="100" r="4" />
        <circle className={styles.cls3} cx="168.48" cy="77.75" r="17" />
        <g>
          <line className={styles.cls4} x1="141" y1="78" x2="63.18" y2="78" />
          <polygon
            className={styles.cls10}
            points="64.64 73.01 56 78 64.64 82.99 64.64 73.01"
          />
        </g>
        <g>
          <line
            className={styles.cls4}
            x1="145.75"
            y1="93.19"
            x2="80.99"
            y2="136.35"
          />
          <polygon
            className={styles.cls10}
            points="79.44 131.39 75.02 140.33 84.97 139.69 79.44 131.39"
          />
        </g>
        <line
          className={styles.cls5}
          x1="15"
          y1="93.51"
          x2="25.5"
          y2="104.01"
        />
        <line
          className={styles.cls5}
          x1="25.5"
          y1="93.51"
          x2="15"
          y2="104.01"
        />
        <g>
          <line
            className={styles.cls5}
            x1="41.53"
            y1="173.7"
            x2="52.03"
            y2="184.2"
          />
          <line
            className={styles.cls5}
            x1="52.03"
            y1="173.7"
            x2="41.53"
            y2="184.2"
          />
        </g>
        <g>
          <path
            className={styles.cls6}
            d="M150.94,33.24c-2.08,0-5.35.51-6.43,1.28-.51,2.25-.63,5.86.45,8.81,1.38,3.76,4.01,2.4,4.01,6.41s-3.99,3.29-4.01,4.81c0,.8,0,0,0,1.6.09.47,5.98.6,5.98.6"
          />
          <path
            className={styles.cls2}
            d="M145.57,38.12c-3.06-2.82-4.81.17-4.81,1.78,0,4.81,6.21,3.85,8.09,5.64"
          />
          <path
            className={styles.cls6}
            d="M150.94,33.24c2.08,0,5.35.51,6.43,1.28.51,2.25.63,5.86-.45,8.81-1.38,3.76-4.01,2.4-4.01,6.41,0,4.01,3.99,3.29,4.01,4.81,0,.8,0,0,0,1.6-.09.47-5.98.6-5.98.6"
          />
          <path
            className={styles.cls2}
            d="M156.3,38.12c3.06-2.82,4.81.17,4.81,1.78,0,4.81-6.21,3.85-8.09,5.64"
          />
        </g>
      </svg>
    </div>
  )
}
